<div class="target-group-container">
  <div class="slider-left">
    <targeting-checkbox
      (onClick)="toggleSingleGender()"
      [checked]="singleGender()"
      [texts]="['Kön']">
    </targeting-checkbox>
    <div class="padding-left--2x margin-top--2x">
      @for(gender of genders(); track gender.id) {
        <div>
          <input
          class="radio"
          id="{{idScope.getOrCreateId(gender.id)}}"
          type="radio"
          name="{{idScope.getOrCreateId('gender')}}"
          [disabled]="!singleGender()"
          [value]="gender"
          [(ngModel)]="selectedGender"
          (ngModelChange)="change()">
        <label
          class="radio" for="{{idScope.getOrCreateId(gender.id)}}" [attr.e2e-id]="gender.name">{{gender.name}}</label>
        </div>
      }
    </div>
  </div>
  <div class="slider-right">
    <targeting-checkbox
      (onClick)="toggleAgeRequired()"
      [checked]="ageRequired()"
      [texts]="['Ålder']">
    </targeting-checkbox>
    <div class="margin-top--1x">
      <ngx-slider [value]="ageMin()" [highValue]="ageMax()" [options]="sliderOptions" (userChange)="onSliderChange($event)"></ngx-slider>
    </div>
  </div>
</div>
